import { IController } from 'angular';

export class InstructionCtrl implements IController {
  static $inject = [];

  constructor() {
    //
  }
}
